var map = {
	"./arg.svg": 939,
	"./aus.svg": 940,
	"./bel.svg": 941,
	"./bra.svg": 942,
	"./can.svg": 943,
	"./cmr.svg": 944,
	"./crc.svg": 945,
	"./cro.svg": 946,
	"./den.svg": 947,
	"./ecu.svg": 948,
	"./eng.svg": 949,
	"./esp.svg": 950,
	"./fra.svg": 951,
	"./ger.svg": 952,
	"./gha.svg": 953,
	"./irn.svg": 954,
	"./jpn.svg": 955,
	"./kor.svg": 956,
	"./ksa.svg": 957,
	"./mar.svg": 958,
	"./mex.svg": 959,
	"./ned.svg": 960,
	"./pol.svg": 961,
	"./por.svg": 962,
	"./qat.svg": 963,
	"./sen.svg": 964,
	"./srb.svg": 965,
	"./sui.svg": 966,
	"./tun.svg": 967,
	"./uru.svg": 968,
	"./usa.svg": 969,
	"./wal.svg": 970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 152;